import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=ba36deee&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.styles.less?vue&type=style&index=0&id=ba36deee&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba36deee",
  null
  
)

export default component.exports